/* SOLANA — comportements site-wide : menu mobile, compteur panier, teaser vidéo. */
(() => {
  /* ---------- Menu mobile ---------- */
  const header = document.querySelector('[data-sp-header]');
  if (header) {
    const burger = header.querySelector('[data-sp-burger]');
    const panel = header.querySelector('.sp-header__panel');
    const setOpen = (open) => {
      header.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    };
    if (burger) {
      burger.addEventListener('click', () => setOpen(!header.classList.contains('is-open')));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && header.classList.contains('is-open')) {
          setOpen(false);
          burger.focus();
        }
      });
      if (panel) {
        panel.addEventListener('click', (event) => {
          if (event.target.closest('a')) setOpen(false);
        });
      }
      window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
        if (event.matches) setOpen(false);
      });
    }
  }

  /* ---------- Compteur panier ---------- */
  const refreshCart = () => {
    const counts = document.querySelectorAll('[data-sp-cart-count]');
    if (!counts.length) return;
    fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        counts.forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          const link = el.closest('[data-sp-cart-link]');
          if (link) link.setAttribute('aria-label', `Panier, ${cart.item_count} article${cart.item_count > 1 ? 's' : ''}`);
        });
      })
      .catch(() => {});
  };
  ['cart:update', 'cart:refresh', 'cart:updated'].forEach((name) => document.addEventListener(name, refreshCart));
  window.addEventListener('pageshow', (event) => { if (event.persisted) refreshCart(); });

  /* ---------- Teaser ----------
   * La vidéo n'est insérée qu'au moment utile :
   * - au clic sur « Lire la vidéo » : lecture avec le son ;
   * - en lecture automatique (réglage) : sans le son, quand la section est
   *   visible, pause hors écran, jamais si le visiteur réduit les animations.
   */
  const safePlay = (video) => {
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
  };

  const mountTeaser = (player, { withSound }) => {
    let video = player.querySelector('video');
    if (!video) {
      const template = player.querySelector('[data-sp-teaser-template]');
      if (!template) return null;
      player.append(template.content.cloneNode(true));
      player.classList.add('is-playing');
      video = player.querySelector('video');
      if (!video) return player.querySelector('iframe');
      video.controls = true;
      video.setAttribute('playsinline', '');
      video.loop = player.dataset.loop === 'true';
    }
    if (withSound) {
      video.removeAttribute('muted');
      video.muted = false;
    } else {
      video.setAttribute('muted', '');
      video.muted = true;
    }
    safePlay(video);
    return video;
  };

  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-sp-teaser-play]');
    if (!play) return;
    const player = play.closest('[data-sp-teaser]');
    if (!player) return;
    player.dataset.userStarted = 'true';
    const media = mountTeaser(player, { withSound: true });
    if (media) media.focus();
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Vidéos de fond : muettes, en boucle, sans interaction ---------- */
  document.querySelectorAll('[data-sp-bgvideo]').forEach((video) => {
    if (reduceMotion) {
      video.pause();
      video.removeAttribute('autoplay');
      video.preload = 'none';
      return;
    }
    video.muted = true;
    video.controls = false;
    video.loop = true;
    /* Relance si le navigateur ou le système la met en pause. */
    video.addEventListener('pause', () => { if (!video.ended && document.visibilityState === 'visible') safePlay(video); });
    video.addEventListener('ended', () => { video.currentTime = 0; safePlay(video); });
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') safePlay(video); });
    video.addEventListener('contextmenu', (event) => event.preventDefault());
    safePlay(video);
  });
  const autoplayers = document.querySelectorAll('[data-sp-teaser][data-autoplay="true"]');
  if (autoplayers.length && !reduceMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const player = entry.target;
        const video = player.querySelector('video');
        if (entry.isIntersecting) {
          if (!video) {
            const mounted = mountTeaser(player, { withSound: false });
            if (mounted && mounted.tagName === 'IFRAME') observer.unobserve(player);
          } else if (video.paused && !video.ended && player.dataset.userPaused !== 'true') {
            safePlay(video);
          }
        } else if (video && !video.paused) {
          player.dataset.autoPaused = 'true';
          video.pause();
        }
      });
    }, { threshold: 0.5 });
    autoplayers.forEach((player) => {
      observer.observe(player);
      /* Une pause demandée par le visiteur est respectée au retour à l'écran. */
      player.addEventListener('pause', (event) => {
        if (player.dataset.autoPaused === 'true') {
          player.dataset.autoPaused = '';
          return;
        }
        if (event.target.tagName === 'VIDEO' && document.visibilityState === 'visible') player.dataset.userPaused = 'true';
      }, true);
      player.addEventListener('play', () => { player.dataset.userPaused = ''; }, true);
    });
  }
})();
